<template>
  <div class="grid-y grid-frame admin-shell">
    <div class="cell auto cell-block-container admin-shell-content">
      <div class="grid-x flex-grow">
        <div class="cell flex shrink admin-navigation-cell">
          <Navigation
            :mobile-open="mobileNavigationOpen"
            @close-mobile="closeMobileNavigation"/>
        </div>
        <button
          type="button"
          class="mobile-navigation-backdrop"
          :class="{ 'is-visible': mobileNavigationOpen }"
          aria-label="Закрыть меню"
          @click="closeMobileNavigation">
        </button>
        <div class="cell auto flex flex-grow section-cell overflow-x-auto">
          <div class="grid-y section flex-grow">
            <router-view name="header">
              <div></div>
            </router-view>
            <div class="cell auto cell-block-container flex flex-col">
              <slot></slot>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Navigation from '@/components/global/navigation/Navigation.vue';

export default {
  components: {
    Navigation,
  },
  data() {
    return {
      mobileNavigationOpen: false,
    };
  },
  methods: {
    toggleMobileNavigation() {
      this.mobileNavigationOpen = !this.mobileNavigationOpen;
    },
    closeMobileNavigation() {
      this.mobileNavigationOpen = false;
    },
    onKeydown(event) {
      if (event.key === 'Escape' && this.mobileNavigationOpen) {
        this.closeMobileNavigation();
      }
    },
    onResize() {
      if (window.innerWidth >= 768 && this.mobileNavigationOpen) {
        this.closeMobileNavigation();
      }
    },
  },
  mounted() {
    this.$eventBus.$on('mobile.navigation.toggle', this.toggleMobileNavigation);
    this.$eventBus.$on('mobile.navigation.close', this.closeMobileNavigation);
    document.addEventListener('keydown', this.onKeydown);
    window.addEventListener('resize', this.onResize);
  },
  beforeDestroy() {
    this.$eventBus.$off('mobile.navigation.toggle', this.toggleMobileNavigation);
    this.$eventBus.$off('mobile.navigation.close', this.closeMobileNavigation);
    document.removeEventListener('keydown', this.onKeydown);
    window.removeEventListener('resize', this.onResize);
  },
};
</script>
